// Payment Method Icons - Brand logos
export const PAYMENT_ICONS = {
  gcash: 'https://customer-assets.emergentagent.com/job_7841fd5b-2ab3-4b27-8187-c957660a6e6b/artifacts/gi9zoknu_b49a5_gcash_refreshes_logo1.jpg',
  maya: 'https://customer-assets.emergentagent.com/job_7841fd5b-2ab3-4b27-8187-c957660a6e6b/artifacts/wfkqrb8a_maya-logo-png_seeklogo-534235.png',
  bank_account: 'https://customer-assets.emergentagent.com/job_7841fd5b-2ab3-4b27-8187-c957660a6e6b/artifacts/rcs8u5zc_Screenshot_20260311_222402.jpg',
  bank_transfer: 'https://customer-assets.emergentagent.com/job_7841fd5b-2ab3-4b27-8187-c957660a6e6b/artifacts/rcs8u5zc_Screenshot_20260311_222402.jpg'
};

// Payment Method Icon Component
export const PaymentIcon = ({ type, size = 'md', className = '' }) => {
  const sizeClasses = {
    sm: 'w-5 h-5',
    md: 'w-8 h-8',
    lg: 'w-12 h-12',
    xl: 'w-16 h-16'
  };

  const iconUrl = PAYMENT_ICONS[type] || PAYMENT_ICONS.bank_account;
  
  return (
    <img 
      src={iconUrl} 
      alt={type || 'payment'} 
      className={`${sizeClasses[size]} object-contain rounded ${className}`}
    />
  );
};

// Helper to get icon URL
export const getPaymentIconUrl = (type) => {
  return PAYMENT_ICONS[type] || PAYMENT_ICONS.bank_account;
};
